import { assert } from './assert';

const BASE = import.meta.env.VITE_API_BASE_URL ?? '/api';

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  assert(path.startsWith('/'), 'path must start with /', { path });
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : null,
  });
  if (!res.ok) {
    const text = await res.text();
    let parsed: unknown = text;
    try { parsed = JSON.parse(text); } catch { /* keep text */ }
    throw new ApiError(res.status, `request_failed: ${res.status}`, parsed);
  }
  if (res.status === 204) return undefined as T;
  return (await res.json()) as T;
}

export const api = {
  get:   <T,>(path: string)            => request<T>('GET', path),
  post:  <T,>(path: string, body: unknown) => request<T>('POST', path, body),
  patch: <T,>(path: string, body: unknown) => request<T>('PATCH', path, body),
  del:   <T,>(path: string)            => request<T>('DELETE', path),
};

// Typed endpoint shapes ------------------------------------------------------

export interface MeBudget {
  budget_id: string;
  period_start: number;
  period_end: number;
  allocated_cents: number;
  consumed_micros: number;
  remaining_micros: number;
  utilization_pct: number;
  events_count: number;
  last_event_at: number | null;
  status: string;
  over_budget: boolean;
}

export interface BurnPoint { bucket_start: number; micros: number; events: number }
export interface BurnSeries { bucket: 'day' | 'hour'; since: number; points: BurnPoint[] }

export interface PeerInfo { role: string; level: string | null; cohort_size: number; your_micros: number; percentile: number | null }
